import React from 'react';
export function HeroSection() {
  return <section className="bg-navy-800 pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-68">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-69">
        <div className="space-y-8" data-id="element-70">
          <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-71">
            40 Rendimiento Alpha:{' '}
            <span className="text-gold-500" data-id="element-72">
              El Protocolo de Virilidad y Energía para el Hombre de Alto
              Desempeño
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-[#e0e0e0] leading-relaxed" data-id="element-73">
            Recupera la potencia, la claridad mental y el vigor de tus 20 años
            sin fármacos, sin dietas extremas y sin perder tiempo en el
            gimnasio.
          </p>
        </div>
        <div className="relative" data-id="element-74">
          <div className="absolute inset-0 bg-gold-500 rounded-2xl blur-3xl opacity-20" data-id="element-75"></div>
          <img src="https://cdn.magicpatterns.com/uploads/dqnKMXpvH89PnY1qFanbWV/heylloyd-image-1774581793702.png" alt="40 Rendimiento Alpha Protocolo en dispositivos" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-76" />
        </div>
      </div>
    </section>;
}